import { Box, HStack } from "@chakra-ui/react";
import { ReactNode } from "react";

interface Props {
  color: string;
  children: ReactNode;
}

export const HlaColoringLegendItem: React.FC<Props> = ({
  color,
  children,
}) => {
  return (
    <HStack>
      <Box
        bg={color}
        w="6px"
        h="6px"
        borderRadius="3px"
        flexShrink={0}
      />
      <Box fontSize="xs">{children}</Box>
    </HStack>
  );
};